import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import { MdClose, MdDownloadDone } from "react-icons/md";
import { GoDownload } from "react-icons/go";
import { FaSpinner } from "react-icons/fa";
import aooz_name from "../assets/aooz_name.png";
import { Update_status_message_qry } from "./update_status_message.js";
import "./DownloadPopup.css"; // 👈 external CSS
import aooz_logo from "../assets/aooz_logo.png";

export default function DownloadPopup({ row, isOpen, onClose }) {
  const panelRef = useRef(null);
  const [downloadingId, setDownloadingId] = useState("");
  const [isCapturing, setIsCapturing] = useState(false);

  // Close on ESC
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape" && isOpen) onClose?.();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  // Close when clicking outside the panel
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && panelRef.current && !panelRef.current.contains(e.target)) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  // Prevent body scroll when popup is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const downloadDivAsImage = async (divId, fileName) => {
    setDownloadingId(divId);
    setIsCapturing(true);

    try {
      const element = document.getElementById(divId);
      if (!element) return;

      const canvas = await html2canvas(element, {
        backgroundColor: null,
        scale: 2,
        useCORS: true,
        logging: false,
      });

      const image = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = image;
      link.download = `${fileName}.png`;
      link.click();

      // Mark as read after successful download
      Update_status_message_qry(row.contentid, "read");

      // Optional: close after a short delay (user sees success)
      setTimeout(() => {
        onClose?.();
      }, 1500);
    } catch (err) {
      console.error("Screenshot error:", err);
    } finally {
      setIsCapturing(false);
      setDownloadingId("");
    }
  };

  if (!isOpen) return null;

  const isDownloading = downloadingId === row.contentid && isCapturing;
  const isDownloaded = downloadingId === row.contentid && !isCapturing;

  return (
    <div className="popup-overlay">
      <div
        ref={panelRef}
        className="download-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="download-dialog-title"
      >
        <div className="panel-header">
          <button
            className="close-btn"
            onClick={onClose}
            aria-label="Close popup"
          >
            <MdClose />
          </button>
          <button
            className={`download-btn ${isDownloading ? "loading" : ""} ${
              isDownloaded ? "success" : ""
            }`}
            onClick={() => downloadDivAsImage(row.contentid, `Aooz.in_${row.statusmood}_${row.contentid}`)}
            disabled={isDownloading || isDownloaded}
          >
            {isDownloading ? (
              <FaSpinner className="spinner" />
            ) : isDownloaded ? (
              <MdDownloadDone />
            ) : (
              <GoDownload />
            )}
            <span>
              {isDownloading
                ? "Preparing..."
                : isDownloaded
                ? "Downloaded"
                : "Download"}
            </span>
          </button>
        </div>

        {/* Preview Area */}
        <div
          id={row.contentid}
          className="preview-card"
          style={{ backgroundColor: row.statuscolor }}
        >
                <img className="logo" src={aooz_logo} alt="Aooz" />
      <div className="status-message">
 
  <span dangerouslySetInnerHTML={{ __html: row.message }} />
 
</div>
       
          <div className="footer">
            <div className="status-info">
              <span className="mood-emoji">{row.statusmoodEmoji}</span>
              <span className="mood-text bold text-h1">#{row.statusmood}</span>
            </div>
            <div className="username text-h1">@{row.accountInfo?.username}</div>
            <div className="text-h1">
              Download more status free: <b>www.aooz.in</b>
            </div>
           <img className="logo_icon" src={aooz_logo} alt="Aooz" />
          </div>
        </div>
      </div>
    </div>
  );
}